<template>
  <div class="parameter">
      <div class="item" v-for="(item,index) in paramsList" :key="index">
        <div v-if="item.type=='INPUT'">
            <span class="name" :style="`flex: ${nameWith}`">{{ item.name }}</span>
            <el-input v-model="item.value" size="small">
                <template slot="suffix" v-if="item.unit">{{item.unit}}</template>
            </el-input>
        </div>
        <div v-if="item.type=='SELECT'">
        <span class="name" :style="`flex: ${nameWith}`">{{ item.name }}</span>
        <el-select v-model="item.value" size="small">
            <el-option
                v-for="optionsItem in item.options"
                :key="optionsItem.value"
                :label="optionsItem.value"
                :value="optionsItem.value">
            </el-option>
        </el-select>
        </div>
        <div v-if="item.type=='RADIO'">
            <span class="name" :style="`flex: ${nameWith}`">{{ item.name }}</span>
        <el-radio-group v-model="item.value" size="small">
            <el-radio v-for="(optionsItem,index) in item.options" :key="index" :label="optionsItem.value">{{optionsItem.value}}</el-radio>
        </el-radio-group>
        </div>
        <div v-if="item.type=='CHECKBOX'">
            <span class="name" :style="`flex: ${nameWith}`">{{ item.name }}</span>
            <el-checkbox-group v-model="item.value" size="small">
                <el-checkbox v-for="(optionsItem,index) in item.options" :key="index" :label="optionsItem.value">{{optionsItem.value}}</el-checkbox>
            </el-checkbox-group>
        </div>
        <div v-if="item.type=='DATE'">
        <span class="name" :style="`flex: ${nameWith}`">{{ item.name }}</span>
        <el-date-picker type="date" size="small" placeholder="选择日期" v-model="item.value"></el-date-picker>
        </div>
    </div>
    <!-- <span @click="reset" class="reset" :style="`right: ${rightNum}`">重置</span> -->
  </div>
</template>

<script>
export default {
    props:{
        paramsList:Array,
        rightNum: String,
        nameWith: String
    },
    data(){
        return{
            list:[]
        }
    },
    watch:{
      paramsList:{
            handler(newval,oldval){
                this.$emit('parameterChange',newval)
            },
            deep:true
        }
    },
    mounted(){
        // this.list = JSON.parse(JSON.stringify(this.paramsList))
        // console.log("list",this.list)
        // this.list = this.list.map(m=>{
        //     return{
        //         ...m,
        //         value:m.type=='CHECKBOX'?[]:''
        //     }
        // })
    },
    methods:{
        reset(){
            this.list = this.list.map(m=>{
                return{
                    ...m,
                    value:m.type=='CHECKBOX'?[]:''
                }
            })
            this.$emit('parameterChange','reset')
        }
    }
}
</script>

<style lang="less" scoped>
.parameter{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    // padding: 10px;
    position: relative;
    .item{
        display: inline-block;
        margin: 10px;
        width: 19%;
        margin-left: 0;
        div{
          display: flex;
          align-items: center;
          .name{
            color: #000;
            font-size: 14px;
            display: inline-block;
            margin-right: 5px;
            // white-space: nowrap;
            width: 88px;
            white-space: nowrap;
            flex-shrink: 0;
            text-align: right;
          }
        }
      }
    .reset{
        color: #2d50a1;
        cursor: pointer;
        position: absolute;
        right: 10%;
        top: 50%;
        transform: translate(0, -50%);
    }
}
</style>



// WEBPACK FOOTER //
// src/components/parameter/Parameter.vue